import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo, useMemo } from 'react';
import { StyleProp, StyleSheet, Text, TextStyle } from 'react-native';

const kDefaultFontSize = 15;

export const PriceInfoView = memo(
  ({
    price,
    discountPrice,
    additionalDiscount = 0,
    discountRemark,
    style,
    priceStyle,
    originalPriceStyle,
    normalTextColor = '#555',
    invalidTextColor = StatusColors.Danger,
    originalPriceTextColor = '#ccc',
  }: {
    price: number | undefined;
    discountPrice: number | undefined;
    additionalDiscount?: number;
    discountRemark?: string;
    style?: StyleProp<TextStyle>;
    normalTextColor?: string;
    invalidTextColor?: string;
    originalPriceTextColor?: string;
    priceStyle?: StyleProp<TextStyle>;
    originalPriceStyle?: StyleProp<TextStyle>;
  }) => {
    const styles = useStyles();

    if (price === -1) {
      price = undefined;
    }

    if (discountPrice === -1) {
      discountPrice = undefined;
    }

    if (price != null) {
      price /= 100;
    }

    if (additionalDiscount != null) {
      additionalDiscount /= 100;
    }

    if (discountPrice != null) {
      discountPrice /= 100;
      discountPrice -= additionalDiscount;
    }

    if (discountPrice == null || discountPrice == price) {
      return (
        <Typography.Text
          color={price == null ? invalidTextColor : normalTextColor}
          style={[{ alignSelf: 'baseline' }, styles.price, style, priceStyle]}
          medium
        >
          {price != null ? `￥${price.toFixed(2)}` : '￥--'}
        </Typography.Text>
      );
    }

    return (
      <Typography.Text
        color={normalTextColor}
        style={[{ alignSelf: 'baseline' }, styles.price, style]}
      >
        <Text style={[{ color: normalTextColor }, priceStyle]}>
          {`￥${discountPrice.toFixed(2)}`}
        </Text>
        <Text>{`  `}</Text>
        <Text
          style={[
            {
              color: originalPriceTextColor,
              textDecorationLine: 'line-through',
            },
            styles.originalPrice,
            originalPriceStyle,
          ]}
        >
          {price != null ? `￥${price.toFixed(2)}` : '￥--'}
        </Text>
        {discountRemark ? (
          <Typography.Text color={StatusColors.Danger}>
            {` [${discountRemark}]`}
          </Typography.Text>
        ) : null}
      </Typography.Text>
    );
  },
);

const useStyles = () => {
  const { rpx } = useResponsiveContext();
  return useMemo(
    () =>
      StyleSheet.create({
        price: {
          fontSize: rpx(kDefaultFontSize),
          fontFamily: FontFamily.NotoSans.Regular,
          fontWeight: 600,
          letterSpacing: rpx(-1.2),
          alignSelf: 'baseline',
          top: rpx(-0.25),
        } as any,
        originalPrice: {
          fontSize: rpx(kDefaultFontSize) * 0.7,
          letterSpacing: rpx(-0.5),
        },
      }),
    [rpx],
  );
};
